import React, { useState } from 'react';
import Button from '../../../components/base/Button';

interface Table {
  id: string;
  name: string;
  status: 'available' | 'occupied' | 'reserved' | 'maintenance';
  capacity?: number;
  currentGuest?: {
    name: string;
    startTime: string;
    partySize: number;
    orderValue?: number;
    estimatedEnd?: string;
    specialRequests?: string;
  };
}

export default function POSSystem() {
  const [cart, setCart] = useState<any[]>([]);
  const [selectedTable, setSelectedTable] = useState('');
  const [customerInfo, setCustomerInfo] = useState({
    name: '',
    phone: '',
    notes: ''
  });
  const [activeCategory, setActiveCategory] = useState('makanan');
  const [searchQuery, setSearchQuery] = useState('');
  const [showAddTableModal, setShowAddTableModal] = useState(false);
  const [showTableDetailModal, setShowTableDetailModal] = useState(false);
  const [selectedTableDetail, setSelectedTableDetail] = useState<Table | null>(null);
  const [newTable, setNewTable] = useState({
    name: '',
    capacity: 4,
    location: ''
  });

  const [tables, setTables] = useState<Table[]>([
    { id: 'A1', name: 'Meja A1', status: 'available', capacity: 4 },
    { 
      id: 'A2', 
      name: 'Meja A2', 
      status: 'occupied', 
      capacity: 4, 
      currentGuest: { 
        name: 'Keluarga Sato', 
        startTime: '19:30', 
        partySize: 3,
        orderValue: 285000,
        estimatedEnd: '21:00',
        specialRequests: 'No spicy food, extra wasabi'
      }
    },
    { id: 'B1', name: 'Meja B1', status: 'available', capacity: 6 },
    { id: 'B2', name: 'Meja B2', status: 'available', capacity: 6 },
    { id: 'C1', name: 'Meja C1', status: 'available', capacity: 8 },
    { id: 'VIP1', name: 'VIP Room 1', status: 'reserved', capacity: 12 },
    { id: 'VIP2', name: 'VIP Room 2', status: 'available', capacity: 12 }
  ]);

  const menuItems = {
    makanan: [
      {
        id: 'ramen-tonkotsu',
        name: 'Tonkotsu Ramen Deluxe',
        price: 75000,
        category: 'Ramen',
        available: true,
        image: 'https://public.readdy.ai/ai/img_res/96f9c6c9b9cd9219962eea4ab41061c7.jpg'
      },
      {
        id: 'sushi-omakase',
        name: 'Omakase Sushi Set',
        price: 150000,
        category: 'Sushi',
        available: true,
        image: 'https://readdy.ai/api/search-image?query=Premium%20omakase%20sushi%20set%20with%2012%20pieces%20of%20nigiri%20sushi%2C%20fresh%20salmon%2C%20tuna%2C%20yellowtail%2C%20sea%20urchin%2C%20elegant%20wooden%20board%20presentation%2C%20wasabi%20and%20pickled%20ginger%2C%20high-end%20Japanese%20restaurant%20quality&width=200&height=150&seq=pos-sushi-omakase&orientation=landscape'
      },
      {
        id: 'tempura-set',
        name: 'Tempura Premium Set',
        price: 85000,
        category: 'Tempura',
        available: true,
        image: 'https://readdy.ai/api/search-image?query=Premium%20tempura%20set%20with%20crispy%20shrimp%20and%20vegetable%20tempura%2C%20golden%20brown%20coating%2C%20tentsuyu%20dipping%20sauce%2C%20elegant%20Japanese%20presentation%2C%20professional%20food%20photography&width=200&height=150&seq=pos-tempura-set&orientation=landscape'
      },
      {
        id: 'gyoza-premium',
        name: 'Gyoza Premium',
        price: 45000,
        category: 'Appetizer',
        available: false,
        image: 'https://readdy.ai/api/search-image?query=Premium%20gyoza%20dumplings%20pan-fried%20until%20golden%20crispy%2C%206%20pieces%20arranged%20on%20black%20plate%2C%20dipping%20sauce%2C%20steam%20rising%2C%20traditional%20Japanese%20appetizer%2C%20restaurant%20quality%20presentation&width=200&height=150&seq=pos-gyoza-premium&orientation=landscape'
      },
      {
        id: 'takoyaki-osaka',
        name: 'Takoyaki Osaka Style',
        price: 35000,
        category: 'Appetizer',
        available: true,
        image: 'https://readdy.ai/api/search-image?query=Osaka%20style%20takoyaki%20octopus%20balls%20with%20takoyaki%20sauce%2C%20mayonnaise%20drizzle%2C%20bonito%20flakes%2C%20seaweed%20powder%2C%206%20pieces%20on%20traditional%20takoyaki%20board%2C%20hot%20and%20steaming%2C%20Japanese%20street%20food&width=200&height=150&seq=pos-takoyaki-osaka&orientation=landscape'
      }
    ],
    minuman: [
      {
        id: 'matcha-latte',
        name: 'Matcha Latte Premium',
        price: 35000,
        category: 'Hot Drinks',
        available: true,
        image: 'https://readdy.ai/api/search-image?query=Premium%20matcha%20latte%20with%20beautiful%20foam%20art%2C%20vibrant%20green%20matcha%20color%2C%20ceramic%20cup%20and%20saucer%2C%20Japanese%20tea%20ceremony%20aesthetic%2C%20modern%20cafe%20presentation%2C%20authentic%20Uji%20matcha&width=200&height=150&seq=pos-matcha-latte&orientation=landscape'
      },
      {
        id: 'ramune-soda',
        name: 'Ramune Soda',
        price: 25000,
        category: 'Cold Drinks',
        available: true,
        image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20ramune%20soda%20bottle%20with%20marble%20ball%2C%20clear%20blue%20tinted%20glass%20bottle%2C%20condensation%20droplets%2C%20refreshing%20summer%20drink%2C%20Japanese%20beverage%2C%20traditional%20packaging&width=200&height=150&seq=pos-ramune-soda&orientation=landscape'
      },
      {
        id: 'green-tea',
        name: 'Ocha (Green Tea)',
        price: 15000,
        category: 'Hot Drinks',
        available: true,
        image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20green%20tea%20ocha%20served%20in%20ceramic%20kyusu%20teapot%20with%20small%20cups%2C%20steam%20rising%2C%20zen%20atmosphere%2C%20traditional%20tea%20ceremony%2C%20minimalist%20presentation&width=200&height=150&seq=pos-ocha-green-tea&orientation=landscape'
      },
      {
        id: 'sake-premium',
        name: 'Sake Premium',
        price: 55000,
        category: 'Alcohol',
        available: true,
        image: 'https://readdy.ai/api/search-image?query=Premium%20Japanese%20sake%20served%20in%20traditional%20ceramic%20tokkuri%20and%20ochoko%20cups%2C%20elegant%20presentation%20on%20wooden%20tray%2C%20warm%20lighting%2C%20traditional%20Japanese%20alcohol%20service%2C%20restaurant%20quality&width=200&height=150&seq=pos-sake-premium&orientation=landscape'
      }
    ]
  };

  const processOrder = async () => {
    // Perbaikan validasi sebelum proses order
    if (cart.length === 0) {
      alert('⚠️ Keranjang masih kosong!\n\nTambahkan item ke keranjang terlebih dahulu.');
      return;
    }

    if (!selectedTable) {
      alert('⚠️ Pilih meja terlebih dahulu!\n\nSilakan pilih meja yang tersedia untuk pesanan ini.');
      return;
    }

    // Validasi total pesanan
    const orderTotal = getTotalPrice();
    if (orderTotal <= 0) {
      alert('⚠️ Total pesanan tidak valid!\n\nPastikan item di keranjang memiliki harga yang benar.');
      return;
    }

    try {
      const orderData = {
        table: selectedTable,
        customer: {
          name: customerInfo.name?.trim() || 'Guest',
          phone: customerInfo.phone?.trim() || '',
          notes: customerInfo.notes?.trim() || ''
        },
        items: cart.map(item => ({
          ...item,
          // Pastikan semua nilai numerik valid
          price: Math.max(0, item.price || 0),
          quantity: Math.max(1, item.quantity || 1)
        })),
        total: orderTotal,
        timestamp: new Date().toISOString()
      };

      console.log('Processing order with data:', orderData);

      const response = await fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/submit-order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`
        },
        body: JSON.stringify(orderData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Order submission result:', result);

      if (result.success) {
        // Update table status to occupied
        setTables(prev => prev.map(t => 
          t.id === selectedTable 
            ? {
                ...t,
                status: 'occupied' as const,
                currentGuest: {
                  name: customerInfo.name?.trim() || 'Guest',
                  startTime: new Date().toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' }),
                  partySize: 1,
                  orderValue: orderTotal
                }
              }
            : t
        ));

        alert(`✅ Pesanan Berhasil Dibuat!\n\nOrder ID: ${result.orderId || 'N/A'}\nMeja: ${selectedTable}\nTotal: Rp ${orderTotal.toLocaleString('id-ID')}\n\nPesanan telah dikirim ke dapur.`);
        clearCart();
      } else {
        throw new Error(result.error || 'Unknown error occurred');
      }
    } catch (error) {
      console.error('Error processing order:', error);
      
      let errorMessage = '❌ Gagal memproses pesanan!\n\n';
      
      if (error instanceof TypeError && error.message.includes('fetch')) {
        errorMessage += 'Koneksi ke server bermasalah. Pastikan koneksi internet stabil dan coba lagi.';
      } else if (error instanceof Error) {
        errorMessage += `Detail error: ${error.message}`;
      } else {
        errorMessage += 'Terjadi kesalahan tidak terduga. Silakan coba lagi atau hubungi admin.';
      }
      
      alert(errorMessage);
    }
  };

  // Perbaikan function getTotalPrice dengan error handling
  const getTotalPrice = () => {
    try {
      return cart.reduce((total, item) => {
        const price = Math.max(0, item.price || 0);
        const quantity = Math.max(1, item.quantity || 1);
        return total + (price * quantity);
      }, 0);
    } catch (error) {
      console.error('Error calculating total price:', error);
      return 0;
    }
  };

  // Perbaikan addToCart dengan validasi
  const addToCart = (item: any) => {
    try {
      if (!item || !item.id) {
        console.error('Invalid item data:', item);
        alert('⚠️ Item tidak valid!');
        return;
      }

      if (!item.available) {
        alert('⚠️ Item ini sedang tidak tersedia!');
        return;
      }

      const existingItem = cart.find(cartItem => cartItem.id === item.id);
      if (existingItem) {
        setCart(cart.map(cartItem => 
          cartItem.id === item.id 
            ? { ...cartItem, quantity: Math.max(1, cartItem.quantity + 1) }
            : cartItem
        ));
      } else {
        setCart([...cart, { 
          ...item, 
          quantity: 1,
          price: Math.max(0, item.price || 0) // Pastikan harga valid
        }]);
      }
    } catch (error) {
      console.error('Error adding item to cart:', error);
      alert('❌ Gagal menambahkan item ke keranjang!');
    }
  };

  // Perbaikan updateQuantity dengan validasi
  const updateQuantity = (itemId: string, quantity: number) => {
    try {
      if (quantity <= 0) {
        removeFromCart(itemId);
      } else {
        // Batasi maksimum quantity untuk mencegah input yang tidak masuk akal
        const maxQuantity = 99;
        const safeQuantity = Math.min(maxQuantity, Math.max(1, Math.floor(quantity)));
        
        setCart(cart.map(item => 
          item.id === itemId ? { ...item, quantity: safeQuantity } : item
        ));
      }
    } catch (error) {
      console.error('Error updating quantity:', error);
      alert('❌ Gagal mengupdate jumlah item!');
    }
  };

  // Perbaikan clearCart
  const clearCart = () => {
    try {
      setCart([]);
      setSelectedTable('');
      setCustomerInfo({ name: '', phone: '', notes: '' });
    } catch (error) {
      console.error('Error clearing cart:', error);
      // Force reload jika ada masalah
      window.location.reload();
    }
  };

  const removeFromCart = (itemId: string) => {
    setCart(cart.filter(item => item.id !== itemId));
  };

  const handleTableClick = (table: Table) => {
    if (table.status === 'available') {
      setSelectedTable(table.id);
    } else {
      // Show table detail modal for occupied/reserved tables
      setSelectedTableDetail(table);
      setShowTableDetailModal(true);
    }
  };

  const addTable = () => {
    if (newTable.name.trim()) {
      const tableId = newTable.name.replace(/\s+/g, '').toUpperCase();
      setTables(prev => [...prev, {
        id: tableId,
        name: newTable.name,
        status: 'available',
        capacity: newTable.capacity
      }]);
      setNewTable({ name: '', capacity: 4, location: '' });
      setShowAddTableModal(false);
    }
  };

  const endTableSession = (tableId: string) => {
    setTables(prev => prev.map(t => 
      t.id === tableId 
        ? { ...t, status: 'available', currentGuest: undefined }
        : t
    ));
    setShowTableDetailModal(false);
    setSelectedTableDetail(null);
  };

  const getEstimatedWaitTime = (table: Table) => {
    if (table.status === 'occupied' && table.currentGuest?.estimatedEnd) {
      const endTime = table.currentGuest.estimatedEnd;
      const currentTime = new Date();
      const currentHour = currentTime.getHours();
      const currentMinute = currentTime.getMinutes();
      const [endHour, endMinute] = endTime.split(':').map(Number);
      
      const currentTotalMinutes = currentHour * 60 + currentMinute;
      const endTotalMinutes = endHour * 60 + endMinute;
      
      if (endTotalMinutes > currentTotalMinutes) {
        const waitMinutes = endTotalMinutes - currentTotalMinutes;
        return `~${Math.ceil(waitMinutes / 15) * 15} menit`;
      }
    }
    return 'Tidak tersedia';
  };

  const filteredItems = menuItems[activeCategory as keyof typeof menuItems].filter(item =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-red-900/20">
      <div className="container mx-auto px-6 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-4xl font-bold text-white mb-2">POS System</h1>
              <p className="text-gray-300">Kelola pesanan dan transaksi restaurant</p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="bg-gradient-to-r from-red-600 to-red-700 px-6 py-3 rounded-xl text-white font-bold">
                <i className="ri-time-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                {new Date().toLocaleTimeString('id-ID', { 
                  hour: '2-digit', 
                  minute: '2-digit',
                  hour12: false 
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="grid xl:grid-cols-7 gap-8">
          {/* Menu Section - 4 columns */}
          <div className="xl:col-span-4 space-y-6">
            <div className="bg-gradient-to-br from-gray-800/90 to-gray-900/90 backdrop-blur-lg rounded-3xl border border-gray-700/50 shadow-2xl">
              <div className="p-6 border-b border-gray-700/50">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-2xl font-bold text-white flex items-center">
                    <i className="ri-restaurant-line mr-3 w-6 h-6 flex items-center justify-center text-red-400"></i>
                    Menu Restaurant
                  </h3>
                  
                  {/* Search Bar */}
                  <div className="relative w-80">
                    <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 flex items-center justify-center"></i>
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Cari menu favorit..."
                      className="w-full pl-12 pr-4 py-3 bg-gray-700/50 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20 transition-all"
                    />
                  </div>
                </div>

                {/* Enhanced Category Tabs */}
                <div className="flex space-x-2">
                  {[
                    { id: 'makanan', name: 'Makanan', icon: 'ri-bowl-line', count: menuItems.makanan.length },
                    { id: 'minuman', name: 'Minuman', icon: 'ri-cup-line', count: menuItems.minuman.length }
                  ].map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setActiveCategory(category.id)}
                      className={`flex items-center space-x-3 px-6 py-3 rounded-xl font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer group ${
                        activeCategory === category.id
                          ? 'bg-gradient-to-r from-red-600 to-red-700 text-white shadow-lg'
                          : 'bg-gray-700/50 text-gray-300 hover:bg-gray-600/70 hover:text-white'
                      }`}
                    >
                      <i className={`${category.icon} w-5 h-5 flex items-center justify-center transition-transform group-hover:scale-110`}></i>
                      <span>{category.name}</span>
                      <span className={`px-2 py-1 rounded-full text-xs font-bold ${
                        activeCategory === category.id 
                          ? 'bg-white/20 text-white' 
                          : 'bg-gray-600 text-gray-300'
                      }`}>
                        {category.count}
                      </span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Enhanced Menu Grid */}
              <div className="p-6">
                <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-4 max-h-[600px] overflow-y-auto custom-scrollbar">
                  {filteredItems.map((item) => (
                    <div
                      key={item.id}
                      className={`group bg-gradient-to-br from-gray-800/60 to-gray-900/60 rounded-2xl border overflow-hidden transition-all duration-300 transform hover:scale-[1.02] cursor-pointer ${
                        item.available 
                          ? 'border-gray-600/50 hover:border-red-500/50 hover:shadow-xl hover:shadow-red-500/10' 
                          : 'border-gray-700/50 opacity-60 cursor-not-allowed'
                      }`}
                      onClick={() => item.available && addToCart(item)}
                    >
                      <div className="relative overflow-hidden">
                        <img
                          src={item.image}
                          alt={item.name}
                          className="w-full h-32 object-cover object-top transition-transform duration-300 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                        
                        {!item.available && (
                          <div className="absolute inset-0 bg-black/70 flex items-center justify-center">
                            <div className="bg-red-500 text-white px-4 py-2 rounded-lg text-sm font-bold flex items-center space-x-2">
                              <i className="ri-close-circle-line w-4 h-4 flex items-center justify-center"></i>
                              <span>Sold Out</span>
                            </div>
                          </div>
                        )}
                        
                        {item.available && (
                          <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <div className="bg-green-500 text-white p-2 rounded-full">
                              <i className="ri-add-line w-4 h-4 flex items-center justify-center"></i>
                            </div>
                          </div>
                        )}
                      </div>
                      
                      <div className="p-4">
                        <div className="mb-2">
                          <h4 className="text-white font-bold text-base mb-1 line-clamp-1 group-hover:text-red-300 transition-colors">
                            {item.name}
                          </h4>
                          <span className="text-gray-400 text-sm bg-gray-700/50 px-2 py-1 rounded-full">
                            {item.category}
                          </span>
                        </div>
                        
                        <div className="flex items-center justify-between">
                          <div className="text-right">
                            <div className="text-yellow-400 font-bold text-lg">
                              Rp {item.price.toLocaleString('id-ID')}
                            </div>
                          </div>
                          
                          {item.available && (
                            <button className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer opacity-0 group-hover:opacity-100">
                              Tambah
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                
                {filteredItems.length === 0 && (
                  <div className="text-center py-16">
                    <div className="w-20 h-20 bg-gray-700/50 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-search-line text-gray-400 text-3xl w-10 h-10 flex items-center justify-center"></i>
                    </div>
                    <p className="text-gray-400 text-lg">Tidak ada menu yang ditemukan</p>
                    <p className="text-gray-500 text-sm mt-2">Coba kata kunci yang berbeda</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Order Management Section - 3 columns */}
          <div className="xl:col-span-3 space-y-6">
            {/* Table Selection Card */}
            <div className="bg-gradient-to-br from-blue-900/20 to-blue-800/20 backdrop-blur-lg rounded-3xl border border-blue-500/30 shadow-2xl">
              <div className="p-6">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-xl font-bold text-white flex items-center">
                    <i className="ri-table-line mr-3 w-5 h-5 flex items-center justify-center text-blue-400"></i>
                    Pilih Meja
                  </h3>
                  <button
                    onClick={() => setShowAddTableModal(true)}
                    className="bg-blue-600 hover:bg-blue-700 text-white p-2 rounded-lg transition-colors cursor-pointer"
                    title="Tambah Meja Baru"
                  >
                    <i className="ri-add-line w-5 h-5 flex items-center justify-center"></i>
                  </button>
                </div>
                
                <div className="grid grid-cols-3 gap-3 max-h-48 overflow-y-auto custom-scrollbar">
                  {tables.map((table) => (
                    <button
                      key={table.id}
                      onClick={() => handleTableClick(table)}
                      className={`relative p-4 rounded-xl text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer group border-2 ${
                        selectedTable === table.id
                          ? 'bg-gradient-to-r from-red-600 to-red-700 text-white border-red-500 shadow-lg'
                          : table.status === 'available'
                          ? 'bg-green-600/20 text-green-400 hover:bg-green-600/30 border-green-500/50 hover:border-green-400'
                          : table.status === 'occupied'
                          ? 'bg-red-600/20 text-red-400 hover:bg-red-600/30 border-red-500/50 hover:border-red-400'
                          : 'bg-gray-800/50 text-gray-500 border-gray-600/50'
                      }`}
                    >
                      <div className="text-center">
                        <div className="font-bold">{table.name}</div>
                        <div className="text-xs opacity-75 mt-1">
                          {table.capacity} kursi
                        </div>
                        {table.status === 'occupied' && table.currentGuest && (
                          <div className="text-xs opacity-90 mt-1 truncate">
                            {table.currentGuest.name}
                          </div>
                        )}
                      </div>
                      
                      {/* Status Indicator */}
                      <div className="absolute -top-1 -right-1">
                        <div className={`w-4 h-4 rounded-full border-2 border-white ${
                          table.status === 'available' ? 'bg-green-500' :
                          table.status === 'occupied' ? 'bg-red-500' :
                          table.status === 'reserved' ? 'bg-yellow-500' :
                          'bg-gray-500'
                        }`}></div>
                      </div>
                      
                      {/* Hover Effect */}
                      <div className="absolute inset-0 bg-white/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </button>
                  ))}
                </div>
                
                {/* Table Status Legend */}
                <div className="flex items-center justify-center space-x-6 mt-4 pt-4 border-t border-blue-500/20">
                  <div className="flex items-center space-x-2 text-xs text-gray-300">
                    <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    <span>Tersedia</span>
                  </div>
                  <div className="flex items-center space-x-2 text-xs text-gray-300">
                    <div className="w-3 h-3 rounded-full bg-red-500"></div>
                    <span>Terisi</span>
                  </div>
                  <div className="flex items-center space-x-2 text-xs text-gray-300">
                    <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                    <span>Reserved</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Customer Information Card */}
            <div className="bg-gradient-to-br from-purple-900/20 to-purple-800/20 backdrop-blur-lg rounded-3xl border border-purple-500/30 shadow-2xl">
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-6 flex items-center">
                  <i className="ri-user-line mr-3 w-5 h-5 flex items-center justify-center text-purple-400"></i>
                  Info Customer
                </h3>
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">Nama Customer</label>
                    <input
                      type="text"
                      value={customerInfo.name}
                      onChange={(e) => setCustomerInfo({...customerInfo, name: e.target.value})}
                      placeholder="Masukkan nama customer"
                      className="w-full px-4 py-3 bg-gray-700/50 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/20 transition-all"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">No. Telepon</label>
                    <input
                      type="tel"
                      value={customerInfo.phone}
                      onChange={(e) => setCustomerInfo({...customerInfo, phone: e.target.value})}
                      placeholder="08xxxxxxxxxx"
                      className="w-full px-4 py-3 bg-gray-700/50 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/20 transition-all"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">Catatan Khusus</label>
                    <textarea
                      value={customerInfo.notes}
                      onChange={(e) => setCustomerInfo({...customerInfo, notes: e.target.value})}
                      placeholder="Allergies, preferences, dll."
                      rows={3}
                      className="w-full px-4 py-3 bg-gray-700/50 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/20 transition-all resize-none"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Shopping Cart Card */}
            <div className="bg-gradient-to-br from-yellow-900/20 to-orange-900/20 backdrop-blur-lg rounded-3xl border border-yellow-500/30 shadow-2xl flex-1">
              <div className="p-6">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-xl font-bold text-white flex items-center">
                    <i className="ri-shopping-cart-line mr-3 w-5 h-5 flex items-center justify-center text-yellow-400"></i>
                    Keranjang Pesanan
                    {cart.length > 0 && (
                      <span className="ml-3 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-bold">
                        {cart.reduce((sum, item) => sum + item.quantity, 0)}
                      </span>
                    )}
                  </h3>
                  
                  {cart.length > 0 && (
                    <button
                      onClick={clearCart}
                      className="text-red-400 hover:text-red-300 p-2 hover:bg-red-500/10 rounded-lg transition-all cursor-pointer"
                      title="Kosongkan Keranjang"
                    >
                      <i className="ri-delete-bin-line w-5 h-5 flex items-center justify-center"></i>
                    </button>
                  )}
                </div>

                {/* Cart Items */}
                <div className="space-y-3 mb-6 max-h-80 overflow-y-auto custom-scrollbar">
                  {cart.length === 0 ? (
                    <div className="text-center py-12">
                      <div className="w-16 h-16 bg-gray-700/50 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-shopping-cart-line text-gray-400 text-2xl w-8 h-8 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-400 text-lg font-medium">Keranjang Masih Kosong</p>
                      <p className="text-gray-500 text-sm mt-2">Pilih menu untuk mulai membuat pesanan</p>
                    </div>
                  ) : (
                    cart.map((item, index) => (
                      <div key={`${item.id}-${index}`} className="bg-gradient-to-r from-gray-800/60 to-gray-900/60 rounded-xl p-4 border border-gray-700/50 hover:border-yellow-500/30 transition-all group">
                        <div className="flex items-start justify-between">
                          <div className="flex-1 min-w-0">
                            <h4 className="text-white font-bold text-sm mb-1 truncate group-hover:text-yellow-300 transition-colors">
                              {item.name}
                            </h4>
                            <p className="text-gray-400 text-xs mb-2">{item.category}</p>
                            <div className="text-yellow-400 font-bold text-sm">
                              Rp {item.price.toLocaleString('id-ID')} × {item.quantity}
                            </div>
                          </div>
                          
                          <div className="flex items-center space-x-2 ml-4">
                            <button
                              onClick={() => updateQuantity(item.id, item.quantity - 1)}
                              className="w-8 h-8 bg-red-600 hover:bg-red-700 text-white rounded-full flex items-center justify-center text-sm transition-colors cursor-pointer"
                            >
                              <i className="ri-subtract-line w-4 h-4 flex items-center justify-center"></i>
                            </button>
                            
                            <span className="text-white font-bold text-lg w-8 text-center">
                              {item.quantity}
                            </span>
                            
                            <button
                              onClick={() => updateQuantity(item.id, item.quantity + 1)}
                              className="w-8 h-8 bg-green-600 hover:bg-green-700 text-white rounded-full flex items-center justify-center text-sm transition-colors cursor-pointer"
                            >
                              <i className="ri-add-line w-4 h-4 flex items-center justify-center"></i>
                            </button>
                          </div>
                        </div>
                        
                        <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-700/50">
                          <div className="text-white font-bold">
                            Subtotal: Rp {(item.price * item.quantity).toLocaleString('id-ID')}
                          </div>
                          
                          <button
                            onClick={() => removeFromCart(item.id)}
                            className="text-red-400 hover:text-red-300 p-1 hover:bg-red-500/10 rounded transition-all cursor-pointer"
                            title="Hapus Item"
                          >
                            <i className="ri-close-line w-4 h-4 flex items-center justify-center"></i>
                          </button>
                        </div>
                      </div>
                    ))
                  )}
                </div>

                {/* Order Summary & Actions */}
                {cart.length > 0 && (
                  <div className="border-t border-yellow-500/30 pt-6">
                    {/* Total Section */}
                    <div className="bg-gradient-to-r from-yellow-600/20 to-orange-600/20 rounded-xl p-4 mb-6 border border-yellow-500/30">
                      <div className="flex items-center justify-between text-xl">
                        <span className="text-white font-bold">Total Pesanan:</span>
                        <span className="text-yellow-400 font-bold">
                          Rp {getTotalPrice().toLocaleString('id-ID')}
                        </span>
                      </div>
                      
                      <div className="flex items-center justify-between text-sm text-gray-300 mt-2">
                        <span>{cart.reduce((sum, item) => sum + item.quantity, 0)} item</span>
                        <span>Meja: {selectedTable || 'Belum dipilih'}</span>
                      </div>
                    </div>
                    
                    {/* Action Buttons */}
                    <div className="space-y-3">
                      <Button
                        variant="primary"
                        size="lg"
                        onClick={processOrder}
                        disabled={cart.length === 0 || !selectedTable}
                        className="w-full whitespace-nowrap cursor-pointer bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 shadow-lg"
                      >
                        <i className="ri-check-line mr-3 w-5 h-5 flex items-center justify-center"></i>
                        Proses Pesanan ({getTotalPrice().toLocaleString('id-ID')})
                      </Button>
                      
                      <div className="grid grid-cols-2 gap-3">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={clearCart}
                          className="w-full whitespace-nowrap cursor-pointer border-red-500 text-red-400 hover:bg-red-500 hover:text-white"
                        >
                          <i className="ri-refresh-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                          Reset
                        </Button>
                        
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => {
                            const orderSummary = cart.map(item => 
                              `${item.quantity}x ${item.name} - Rp ${(item.price * item.quantity).toLocaleString('id-ID')}`
                            ).join('\n');
                            
                            const summary = `📋 RINGKASAN PESANAN\n\n${orderSummary}\n\n💰 Total: Rp ${getTotalPrice().toLocaleString('id-ID')}\n🪑 Meja: ${selectedTable || 'Belum dipilih'}\n👤 Customer: ${customerInfo.name || 'Guest'}`;
                            
                            navigator.clipboard.writeText(summary).then(() => {
                              alert('✅ Ringkasan pesanan berhasil disalin!');
                            }).catch(() => {
                              alert('📋 Ringkasan Pesanan:\n\n' + summary);
                            });
                          }}
                          className="w-full whitespace-nowrap cursor-pointer border-blue-500 text-blue-400 hover:bg-blue-500 hover:text-white"
                        >
                          <i className="ri-file-copy-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                          Copy
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Detail Modal */}
      {showTableDetailModal && selectedTableDetail && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 z-50">
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl border border-red-500/20 max-w-md w-full">
            <div className="p-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-2xl font-bold text-white">Detail {selectedTableDetail.name}</h3>
                <button
                  onClick={() => setShowTableDetailModal(false)}
                  className="w-10 h-10 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-white w-5 h-5 flex items-center justify-center"></i>
                </button>
              </div>

              <div className="space-y-6">
                {/* Table Status */}
                <div className="bg-gray-900/50 rounded-2xl p-4 border border-gray-700">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <h4 className="text-lg font-bold text-white">{selectedTableDetail.name}</h4>
                      <p className="text-gray-300 text-sm">Kapasitas: {selectedTableDetail.capacity} orang</p>
                    </div>
                    <div className={`px-3 py-1 rounded-full text-xs font-bold ${
                      selectedTableDetail.status === 'occupied' ? 'bg-red-500 text-white' : 
                      selectedTableDetail.status === 'reserved' ? 'bg-yellow-500 text-black' : 
                      'bg-green-500 text-white'
                    }`}>
                      {selectedTableDetail.status === 'occupied' ? 'Terisi' : 
                       selectedTableDetail.status === 'reserved' ? 'Reserved' : 
                       'Tersedia'}
                    </div>
                  </div>
                </div>

                {/* Current Guest Info */}
                {selectedTableDetail.status === 'occupied' && selectedTableDetail.currentGuest && (
                  <div className="bg-red-900/20 rounded-2xl p-4 border border-red-500/30">
                    <h4 className="text-lg font-bold text-red-400 mb-4">
                      <i className="ri-user-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                      Tamu Saat Ini
                    </h4>
                    <div className="space-y-3 text-sm">
                      <div className="flex justify-between">
                        <span className="text-gray-300">Nama:</span>
                        <span className="text-white font-semibold">{selectedTableDetail.currentGuest.name}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-300">Jumlah Tamu:</span>
                        <span className="text-white">{selectedTableDetail.currentGuest.partySize} orang</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-300">Mulai Makan:</span>
                        <span className="text-white">{selectedTableDetail.currentGuest.startTime}</span>
                      </div>
                      {selectedTableDetail.currentGuest.estimatedEnd && (
                        <div className="flex justify-between">
                          <span className="text-gray-300">Estimasi Selesai:</span>
                          <span className="text-yellow-400 font-bold">{selectedTableDetail.currentGuest.estimatedEnd}</span>
                        </div>
                      )}
                      {selectedTableDetail.currentGuest.orderValue && (
                        <div className="flex justify-between">
                          <span className="text-gray-300">Nilai Pesanan:</span>
                          <span className="text-green-400 font-bold">Rp {selectedTableDetail.currentGuest.orderValue.toLocaleString('id-ID')}</span>
                        </div>
                      )}
                      {selectedTableDetail.currentGuest.specialRequests && (
                        <div>
                          <span className="text-gray-300">Permintaan Khusus:</span>
                          <p className="text-white text-xs mt-1 bg-gray-800/50 rounded-lg p-2">
                            {selectedTableDetail.currentGuest.specialRequests}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Wait Time Info */}
                {selectedTableDetail.status === 'occupied' && (
                  <div className="bg-blue-900/20 rounded-2xl p-4 border border-blue-500/30">
                    <h4 className="text-lg font-bold text-blue-400 mb-3">
                      <i className="ri-time-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                      Estimasi Ketersediaan
                    </h4>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-white mb-2">
                        {getEstimatedWaitTime(selectedTableDetail)}
                      </div>
                      <p className="text-gray-300 text-sm">
                        Estimasi waktu tunggu hingga meja tersedia
                      </p>
                    </div>
                  </div>
                )}

                {/* Actions */}
                <div className="space-y-3">
                  {selectedTableDetail.status === 'occupied' && (
                    <>
                      <Button
                        variant="outline"
                        size="lg"
                        onClick={() => {
                          // Add additional order functionality
                          setSelectedTable(selectedTableDetail.id);
                          setShowTableDetailModal(false);
                        }}
                        className="w-full whitespace-nowrap cursor-pointer border-yellow-500 text-yellow-400 hover:bg-yellow-500 hover:text-black"
                      >
                        <i className="ri-add-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                        Tambah Pesanan
                      </Button>
                      
                      <Button
                        variant="outline"
                        size="lg"
                        onClick={() => endTableSession(selectedTableDetail.id)}
                        className="w-full whitespace-nowrap cursor-pointer border-green-500 text-green-400 hover:bg-green-500 hover:text-white"
                      >
                        <i className="ri-check-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                        Selesai & Kosongkan Meja
                      </Button>
                    </>
                  )}
                  
                  <Button
                    variant="primary"
                    size="lg"
                    onClick={() => setShowTableDetailModal(false)}
                    className="w-full whitespace-nowrap cursor-pointer"
                  >
                    Tutup
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Table Modal */}
      {showAddTableModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 z-50">
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-red-500/20 rounded-2xl max-w-md w-full">
            <div className="flex items-center justify-between p-6 border-b border-gray-700">
              <h3 className="text-xl font-bold text-white">Tambah Meja Baru</h3>
              <button
                onClick={() => setShowAddTableModal(false)}
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line w-6 h-6 flex items-center justify-center"></i>
              </button>
            </div>

            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Nama Meja *</label>
                <input
                  type="text"
                  value={newTable.name}
                  onChange={(e) => setNewTable({...newTable, name: e.target.value})}
                  placeholder="contoh: Meja D1"
                  className="w-full px-3 py-2 bg-gray-700/50 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-red-500 focus:outline-none"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Kapasitas</label>
                <select
                  value={newTable.capacity}
                  onChange={(e) => setNewTable({...newTable, capacity: parseInt(e.target.value)})}
                  className="w-full px-3 py-2 bg-gray-700/50 border border-gray-600 rounded-lg text-white focus:border-red-500 focus:outline-none pr-8"
                >
                  <option value={2}>2 orang</option>
                  <option value={4}>4 orang</option>
                  <option value={6}>6 orang</option>
                  <option value={8}>8 orang</option>
                  <option value={10}>10 orang</option>
                  <option value={12}>12 orang</option>
                </select>
              </div>
            </div>

            <div className="flex justify-end space-x-3 p-6 border-t border-gray-700">
              <button
                onClick={() => setShowAddTableModal(false)}
                className="px-4 py-2 text-gray-300 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Batal
              </button>
              <button
                onClick={addTable}
                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Tambah Meja
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
